module.exports = __webpack_public_path__ + "img/top-gear-A_146x146.11cf0ec8.png";